import { Box, Paper, Typography } from '@mui/material'
import React from 'react'
import { brandImages } from '../../../constants/brands'
const TyreView = ({
  data,
  claimed = false,
  clickable = false,
  clicked = false,
  onClick,
  ...rest
}) => {
  if (!data) {
    return (
      <Paper
        variant='outlined'
        sx={{
          bgcolor: 'text.disabled',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: 112,
        }}
      >
        <Typography variant='body1' textAlign='center'>
          N/A
        </Typography>
      </Paper>
    )
  }

  return (
    <Paper
      variant={(clickable && clicked) || claimed ? 'outlined' : undefined}
      {...rest}
      sx={{
        p: 2,
        backgroundColor: claimed ? '#ffd586' : clickable && clicked ? '#dddddd' : undefined,
        transition: '200ms',
        ':hover': {
          backgroundColor: clickable ? '#eeeeee' : undefined,
        },
        opacity: claimed && 0.5,
        cursor: clickable ? 'pointer' : undefined,
        ...rest.sx,
      }}
      onClick={clickable ? onClick : undefined}
    >
      <Box display='flex' width='100%' justifyContent='center'>
        <Box
          component='img'
          sx={{ height: { xs: 32, md: 52 } }}
          src={`/images/logos/transparent/${brandImages[data.brand.name] || data.brand.name}.png`}
          alt={data.brand.fullName}
        />
      </Box>
      <Box display='flex' width='100%' justifyContent='center'>
        <Typography variant='subtitle1' textAlign='center'>
          {data.model.fullName}
        </Typography>
      </Box>
      <Box display='flex' width='100%' justifyContent='center'>
        <Typography variant='body2' color='textSecondary' textAlign='center'>
          {data.size.full}
        </Typography>
      </Box>
      {data.localNum && (
        <Box display='flex' width='100%' justifyContent='center'>
          <Typography variant='body2' color='textSecondary' textAlign='center'>
            ({data.localNum})
          </Typography>
        </Box>
      )}
    </Paper>
  )
}

export default TyreView
